import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import { leaderboardFragment } from '@layouts/leaderboard/leaderboard-fragment'
import { marketingFormEmbedFragment } from '@components/marketing-form-embed/marketing-form-embed.fragment'
import { wscIntegrationFragment } from '@components/wsc-story-widget/wsc-integration.fragment'
import LeaderboardLanding from './index'

export const externalLeaderboardFragmentLight = `
  headline
  tourName
  status
  location
  dates
  externalUrl
`

export const externalLeaderboardFragment = `
  headline
  tourName
  status
  location
  dates
  externalUrl
  ${wscIntegrationFragment}
`

const QUERY = gql`
query LeaderboardLandingPage($preview: Boolean)  {
    leaderboardLandingCollection(limit: 1, preview: $preview)  {
    items {
      title
      metaTitle
      metaDescription
      metaImage {
        url
      }
      newsletterSignup {
        ${marketingFormEmbedFragment}
      }
      leaderboardsCollection {
        items {
          ${leaderboardFragment}
        }
      }
      externalLeaderboardsCollection {
        items {
          ${externalLeaderboardFragment}
        }
      }
    }
  }
}
`

export default function LeaderboardLandingWithData(props) {
  const { query } = props
  return (
    <Query query={QUERY} variables={query}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} displayErrorType="page" />
        if (loading) return <LinearProgress color="secondary" />

        const response = data.leaderboardLandingCollection
          && data.leaderboardLandingCollection.items[0]

        return response ? (
          <LeaderboardLanding {...response} {...props} />
        ) : <Error statusCode={404} />
      }}
    </Query>
  )
}

LeaderboardLandingWithData.propTypes = {
  query: PropTypes.object,
}
